import * as yup from 'yup';
import { isValid, parse } from 'date-fns';
import { FIELD_MIN_LENGTH, INCORRECT_DATE } from 'core/constants';
import { onlyNumbers } from '../parsers';

export type ValidateMinLengthType = {
  message?: string;
  from: number;
  to: number;
  transform?: {
    regular: RegExp;
    excludeLength?: number;
  };
};

function validateMinLength(this: yup.StringSchema, data: ValidateMinLengthType) {
  const { transform, message, to, from } = data;
  const errorMessage = {
    message: message || FIELD_MIN_LENGTH,
    data: {
      from,
      to,
    },
  };

  return this.test({
    name: 'validateMinLength',
    message: errorMessage,
    test: (value) => {
      if (!value) return true;

      let curVal = value;
      if (transform) {
        const { excludeLength = 0, regular } = transform;
        curVal = regular ? curVal.replace(regular, '') : curVal;
        if (curVal.length <= excludeLength) return true;
      }

      errorMessage.data.from = curVal.length;
      return from ? curVal.length >= from && curVal.length <= to : curVal.length === to;
    },
  });
}

function validateCodePhone(
  this: yup.StringSchema,
  codes: Array<number | string>,
  message = 'incorrect_phone_code'
) {
  return this.test({
    name: 'validateCodePhone',
    message,
    test: (value) => {
      if (!value) return true;
      const codeLength = `${codes[0]}`.length;
      const val = onlyNumbers(value);
      const searchStr = val.length < codeLength ? val : val.slice(0, codeLength);
      return codes.some((code) => `${code}`.slice(0, searchStr.length).includes(searchStr));
    },
  });
}

export type CorrectDateType = {
  message?: string;
  format?: string;
};

function correctDate(this: yup.StringSchema, data?: CorrectDateType) {
  return this.test({
    name: 'isCorrectDate',
    message: data?.message || INCORRECT_DATE,
    test: (value) => {
      if (!value) return true;
      const date = data?.format ? parse(value, data.format, new Date()) : value;
      return isValid(new Date(date));
    },
  });
}

yup.addMethod<yup.StringSchema>(yup.string, 'validateMinLength', validateMinLength);
yup.addMethod<yup.StringSchema>(yup.string, 'validateCodePhone', validateCodePhone);
yup.addMethod<yup.StringSchema>(yup.string, 'isCorrectDate', correctDate);

export default yup;
